import {Component, OnDestroy, OnInit} from '@angular/core';
import {MvsObjectNavigationService} from "../../mvs-object-navigation.service";
import {MvsObjectNavigationEntry} from "../../mvs-object-navigation-entry";
import {BehaviorSubject} from "rxjs";
import {MvsObjectNavigationProviderInterface} from "../../mvs-object-navigation-provider.interface";
import {MenuItem} from "primeng/api";

@Component({
    selector: 'mvs-object-navigation-menu',
    templateUrl: './mvs-object-navigation-menu.component.html',
    standalone: false
})
export class MvsObjectNavigationMenuComponent
      implements OnInit, OnDestroy {

  navigationPathList : { label: string, entry: MvsObjectNavigationEntry }[] = [];

  navigationObject: BehaviorSubject<MvsObjectNavigationEntry>;
  navSearch: string;

  navigationEntriesMenu: MenuItem[];
  navigationEntries: MvsObjectNavigationEntry[];
  navigationWithChildList: boolean;


  initialized: boolean = false;
  busy: boolean = false;

  constructor(
      protected navigationService: MvsObjectNavigationService
  ) {
  }

  /**
   * Change navigation Entry.
   * @param event
   */
  onNavigationEntrySelect(event: any) {

    const navigationEntry = event.item["navigationEntry"];

    if (navigationEntry.objectIdentifier.objectType) {
      this.navigationService.navigateTo(navigationEntry);
    }

  }

  /**
   * Initialization.
   */
  ngOnInit(): void {


    // react on provider change
    this.navigationService.getNavigationProvider().subscribe(navProvider => {

      if (navProvider) {
        this.initialized = true;

        const latestNavigationObject = this.navigationService.getNavigationObject().getValue();

        this.refreshNavigation(navProvider, latestNavigationObject);

      } else {
        // clear pathlist
        this.initialized = false;
      }
    });

    // react on navigation node change
    this.navigationService.getNavigationObject().subscribe(navigationObject => {

      // get the latest navigation provider
      const latestNavProvider = this.navigationService.getNavigationProvider().getValue();

      this.refreshNavigation(latestNavProvider, navigationObject);

    });
  }

  refreshNavigation(navProvider: MvsObjectNavigationProviderInterface, navObject: MvsObjectNavigationEntry) {

    if (navObject) {

      if (navObject.objectIdentifier.objectId) {
        // we'll retrieve two levels bellow (because we could have some group->type assignments)
        this.navigationEntries = navProvider.getNavigationEntriesFromObject(navObject.objectIdentifier, 2).entries;
      } else {
        this.navigationEntries = navProvider.getNavigationEntriesFromObject(navObject.objectIdentifier, 1).entries;
      }


    } else {
      this.navigationEntries = navProvider.getNavigationEntriesFromObject(null, 1).entries;
    }
    this.refreshUi();

  }

  refreshUi() {

    this.navigationEntriesMenu = [];
    this.refreshNavigationEntries(null, this.navigationEntries, this.isChildListInNavigation(this.navigationEntries));

  }

  protected isChildListInNavigation(entries: MvsObjectNavigationEntry[]): boolean{
    if (!entries) {
      return false;
    }
    for (const entry of entries) {
      if (entry.children){
        return true;
        break;
      }
    }
    return false;
  }

  refreshNavigationEntries(parent: MenuItem, entries: MvsObjectNavigationEntry[], hasChildList: boolean) {

    if (!entries) {
      return;
    }

    for (let entry of entries) {

      let menuItem = {
        label: entry.name,
        icon: !entry.objectIdentifier.objectId ? 'pi pi-fw pi-plus' : entry.image || '',
        command : (event) => {
                  this.onNavigationEntrySelect(event);
                },
        navigationEntry : entry
      };

      if (!entry.children && hasChildList){
        menuItem.label = 'Optionen';
        this.refreshNavigationEntries(menuItem,[entry],false );
      }
      if (entry.children && entry.objectIdentifier.objectId && hasChildList) {
        menuItem.label = 'Gruppe';
        this.refreshNavigationEntries(menuItem, [entry], this.isChildListInNavigation(entry.children));
      }
      if (entry.children) {
        this.refreshNavigationEntries(menuItem, entry.children, this.isChildListInNavigation(entry.children));
      }
      if (!parent) {
        if(!entry.objectIdentifier.objectId){
          this.navigationEntriesMenu.unshift(menuItem)
        }else {
          this.navigationEntriesMenu.push(menuItem);
        }
      } else {
        if (!parent.items) {
          parent.items = [];
        }
        if(!entry.objectIdentifier.objectId){
          parent.items.unshift(menuItem);
        }else {
          parent.items.push(menuItem);
        }

      }

    }
  }

  convertNavigationPaths(navPathEntries : MvsObjectNavigationEntry[]) {

    this.navigationPathList = [];

    if (!navPathEntries) {
      return;
    }

    for (let navPathEntry of navPathEntries) {
      this.navigationPathList.push({label:navPathEntry.name, entry: navPathEntry});
    }
  }


  /**
   * Clean up.
   */
  ngOnDestroy(): void {
    if (this.navigationObject) {
      this.navigationObject.unsubscribe();
    }

  }


}
